<template>
	<div class="mobileSignersContainer">
		<div class="mobileSignersHeader">
			<p class="mobileSignersHeaderText">
				All Signers
			</p>
			<a class="mobileSignersCloseButton" />
			<a class="mobileSignersHideButton">Hide</a>
		</div>
		<signers-list
			:signers="principalSigners"
			header="Principal Signers"
			:is-mobile="true"
			class="signer"
			:show-initials-wrapper="false"
		/>
		<signers-list
			:signers="witnesses"
			header="Witnesses"
			:is-mobile="true"
			class="witness"
			:show-initials-wrapper="false"
		/>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import SignersList from "./SignersList.vue";

export default {
	components: { SignersList },
	computed: {
		...mapGetters(`Signers`, [`principalSigners`, `witnesses`]),
	},
};
</script>